var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Resizer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var viewport = ref.viewport;
return [_c('div',{staticClass:"columns"},_vm._l((_vm.cols),function(col){return _c('span',{key:("col-" + col),ref:"boxes",refInFor:true,staticClass:"box",style:({
        width: ((Math.round(viewport.width / _vm.cols)) + "px"),
        left: ((Math.round(viewport.width / _vm.cols) * (col - 1)) + "px"),
      })})}),0)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }